var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.806,
    height: 20.3,
    viewBox: "0 0 22.806 20.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Flight",
    d: "M7.056,1.006a.7.7,0,0,0-.6.338.724.724,0,0,0-.032.7L9.407,8.146,4.848,8.16l-.72-1.119a.7.7,0,0,0-.589-.327H.721a.7.7,0,0,0-.586.317.724.724,0,0,0-.067.67L1.394,11,.068,14.309a.724.724,0,0,0,.069.667.7.7,0,0,0,.583.315H3.539a.7.7,0,0,0,.589-.322l.719-1.108H9.421L6.457,19.977a.724.724,0,0,0,.034.692.7.7,0,0,0,.6.338H9.905a.7.7,0,0,0,.578-.306L15.2,13.862h4.5a2.86,2.86,0,0,0,0-5.719H15.151l-4.7-6.83a.7.7,0,0,0-.578-.307Zm1.136,1.43H9.508l4.7,6.834a.7.7,0,0,0,.575.3H19.7A1.4,1.4,0,0,1,21.108,11a1.422,1.422,0,0,1-.407,1.017,1.38,1.38,0,0,1-1,.413H14.833a.7.7,0,0,0-.575.307L9.54,19.575H8.22l2.962-6.111a.724.724,0,0,0-.034-.694.7.7,0,0,0-.6-.337H4.466a.7.7,0,0,0-.589.325l-.719,1.105H1.769l1.04-2.588a.725.725,0,0,0,0-.539L1.769,8.143H3.156l.721,1.122a.7.7,0,0,0,.592.325l6.073-.02a.7.7,0,0,0,.6-.337.724.724,0,0,0,.034-.692Z",
    transform: "translate(0.141 -0.856)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/Flight.01839dc97f0b2770b74c815f2bf61cd0.svg";
export { ForwardRef as ReactComponent };